import { render } from "./PresenceView.vue?vue&type=template&id=8f596e5e"
import script from "./PresenceView.vue?vue&type=script&lang=js"
export * from "./PresenceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__